{
  "about": "About {{name}}",
  "cancel": "Cancel",
  "changes": {"added": "Added:", "changed": "Changed:", "removed": "Removed:"},
  "close": "Close",
  "copyReference": {"copied": "Copied", "failed": "Couldn't copy", "label": "Copy reference"},
  "loading": "Loading…",
  "settings": {
    "reason": "Reason",
    "reasonHint": "Why this changes. Everyone who reads the history sees it.",
    "save": "Save"
  },
  "source": {
    "copy": "Copy",
    "layout": "Layout",
    "loadingEditor": "Loading the editor…",
    "nextChange": "Next change",
    "noChanges": "No changes.",
    "openComparison": "Open comparison",
    "openFull": "Open full view",
    "previousChange": "Previous change",
    "showUnchanged_one": "Show {{count}} unchanged line",
    "showUnchanged_other": "Show {{count}} unchanged lines",
    "sideBySide": "Side by side",
    "unified": "Unified"
  },
  "typeToConfirm": "To confirm, type “{{text}}”"
}
